import { Link } from "react-router-dom";
import { PLATFORM_ARTICLES } from "../lib/platformArticles";
import EventsPage from "./EventsPage";

/** Front page of the RC Race HQ service site (www / www-dev). A club's own
 *  domain keeps the club front page in HomePage instead. */
export default function ServiceHomePage() {
  return (
    <div>
      <section className="full-bleed service-hero">
        <h1>Race day for RC clubs</h1>
        <p className="service-hero-lead">
          Events, registration, heats and race-day media for your club, on your own domain. One
          account for racers at every track.
        </p>
        <div className="service-hero-actions">
          <Link to="/events" className="btn">Find a race</Link>
          <Link to="/about" className="btn secondary">Bring your club</Link>
        </div>
      </section>

      <section className="service-features">
        <div className="card">
          <h3>Registration and heats</h3>
          <p>Online entry and payment, then qualifying heats and mains laid out in run order.</p>
        </div>
        <div className="card">
          <h3>Your club, your site</h3>
          <p>Your domain, your name, your events, news and hobby shops.</p>
        </div>
        <div className="card">
          <h3>Live and media</h3>
          <p>LiveRC and embedded streams, plus race-day photos and video grouped by event.</p>
        </div>
      </section>

      <h2>Learn more</h2>
      <div className="events-grid single-column">
        {PLATFORM_ARTICLES.map((a) => (
          <Link key={a.slug} to={`/platform/${a.slug}`} className="card event-card">
            <h3>{a.title}</h3>
            <p>{a.summary}</p>
          </Link>
        ))}
      </div>

      <div style={{ marginTop: "2rem" }} />
      <EventsPage moreLinkTo="/events" />
    </div>
  );
}
